function initializeGainsightPX() {
    if (this.isGainsightPXInitialized) return;

    // Gainsight PX Tag
    (function(n, t, a, e, x) {
        let i = 'aptrinsic';
        (n[i] =
            n[i] ||
            function() {
                (n[i].q = n[i].q || []).push(arguments);
            }),
            (n[i].p = e),
            (n[i].c = x);

        let r = t.createElement('script');
        r.async = !0;
        r.src = a + '?a=' + e;

        let c = t.getElementsByTagName('script')[0];
        c.parentNode.insertBefore(r, c);
    })(
        window,
        document,
        'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
        'AP-BMT7BXSFHQUE-2-3',
        { iframeModeEnabled: false, allowCrossDomain: true }
    );

    this.isGainsightPXInitialized = true;
}

initializeGainsightPX();
